<mat-card appearance="outlined" style="margin-bottom: 10px">
  <mat-card-content>
    <div *ngIf="perfil === 'ALUNO_ESPECIAL' || perfil === 'ALUNO_REGULAR'">
      <b>{{ ra }}</b> | {{ nome }}<span *ngIf="programa"> - {{ programa }}</span>
      <span *ngIf="curso"> - {{ curso | nivelPrograma }}</span>
    </div>
    <div *ngIf="perfil !== 'ALUNO_ESPECIAL' && perfil !== 'ALUNO_REGULAR'">
      {{ nome }} | <b>{{ perfil | perfil }}</b> <span *ngIf="campus"> - {{ campus }}</span>
    </div>
  </mat-card-content>
</mat-card>
